import { useLang } from '@/i18n';
import EcoButton from 'eco-design/base/eco-button';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styled from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        theme: 'black',
        heightType: 'full-screen',
        // isVideo: true,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745586980772/ultar-kv.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745587078982/ultra-m-kv.jpg',
        label: t('label'),
        labelColor: '#fff',
        title: t('title'),
        subTitle: t('desc'),
        subTitleColor: '#fff',
        titleColor: '#fff',
        // rBtnIsYouToBe: true,
        // rChildren: 'Watch video',
        // rHref: 'https://www.youtube.com/embed/zsonj2HPQdM?si=2GSK67QBoFc7Azgk',
        // rType: 'outlined',
        // rBorderColor: '#fff',
        // rFontColor: '#fff',
    };
    return (
        <div id="banner" className={styled.banner}>
            <EcoBanner theme="black" {...dataA} />
        </div>
    );
}
